module.exports = __webpack_public_path__ + "img/regist-method-image.c4ba1b90.svg";